/* src/app/components/acceptance-modal/acceptance-modal.component.css */
ion-card {
  margin: 0 !important;
  padding: 20px;
}
ion-card-header {
  text-align: center;
}
@media (max-width: 576px) {
  ion-card {
    padding: 5px;
  }
}
ion-button {
  font-weight: 600;
}
ion-card-title {
  font-size: 24px;
}
/*# sourceMappingURL=acceptance-modal.component-UVBNANBH.css.map */
